import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import packageJson from '@root/package.json';

@Component({
  selector: 'a360-version',
  templateUrl: 'version.component.html',
  styleUrls: ['version.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class VersionComponent {
  @Input() collapsed = false;

  public appVersion: string = packageJson.version;

  constructor() {}
}
